import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase/db";
import { EVENT } from "../../../constants/routes";
import { EventI } from "../../../types/types";

const CreateEvent = () => {
  let navigate = useNavigate();
  const [events, setEvents] = useState<Array<EventI>>([]);

  useEffect(() => {
    const getEvents = async () => {
      const events = await db.events.getAll();
      setEvents(events);
    };

    getEvents();
  }, []);

  return (
    <div className="w-full flex flex-col items-center mt-7">
      <div className="w-full max-w-lg">
        <h2 className="text-2xl mb-5">Events</h2>
        <div className="w-full flex flex-col m-4 md:m-0">
          <div className="flex flex-col gap-2">
            {events.map((event) => (
              <div
                key={event.id}
                onClick={() => navigate(`../${EVENT}/${event.id}`)}
                className="cursor-pointer link link-hover"
              >
                <h3>
                  {event.eventName} - {event.datetime}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateEvent;
